<template>
    <section
        v-if="days.length"
        class="package-itinerary"
    >
        <h2 class="k-heading-3">
            Day-by-day itinerary
        </h2>

        <KSteps
            collapsible
            :default-value="stepValue(days[0], 0)"
        >
            <KStep
                v-for="(day, index) in days"
                :key="stepValue(day, index)"
                :value="stepValue(day, index)"
                :title="day.title"
            >
                <div
                    v-if="day.description"
                    class="package-itinerary__text k-prose"
                    v-html="renderRichText(day.description)"
                />
                <NuxtImg
                    v-if="day.image?.filename"
                    :src="day.image.filename"
                    :alt="day.image.alt || day.title"
                    width="720"
                    height="405"
                    fit="cover"
                    format="auto"
                    loading="lazy"
                    sizes="xs:100vw sm:100vw md:640px"
                    class="package-itinerary__image"
                />
            </KStep>
        </KSteps>
    </section>
</template>

<script setup>
import { KStep, KSteps } from '@vemedia/karibu'

const { days } = defineProps({
    days: {
        type: Array,
        default: () => [],
    },
})

// KSteps addresses a step by value, so the day's Storyblok uid is the natural key — the index
// only stands in for a day saved before uids, which must still be openable.
function stepValue(day, index) {
    return day?._uid || `day-${index}`
}
</script>

<style lang="scss" scoped>
// The frame, the numbering and the disclosure are KSteps'. What is left here is the section's
// place on the page and the styling of the Storyblok content inside each step.
.package-itinerary {
    margin-top: var(--space-7);

    > h2 {
        margin-bottom: var(--space-4);
    }

    &__image {
        display: block;
        width: 100%;
        height: auto;
        margin-top: var(--space-4);
        border-radius: var(--radius-5);
        aspect-ratio: 16 / 9;
        object-fit: cover;
    }
}
</style>
